<template>
  <div class="info">
    <div class="header">
      <div class="song-details">
        <div class="song-title">
          {{ song.title }}
        </div>
        <div class="attributes">
          <div class="attribute">
            <span class="icon">
              <i class="mdi mdi-calendar" />
            </span>
            <span>{{ song.year }}</span>
          </div>
          <div class="attribute">
            <span class="icon">
              <i class="mdi mdi-earth" />
            </span>
            <span>{{ $t('country.' + song.country_origin) }}</span>
          </div>
          <div class="attribute">
            <span class="icon">
              <i class="mdi mdi-translate" />
            </span>
            <span>{{ $t('language.' + song.language.capitalize()) }}</span>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="song.note"
      class="note"
    >
      {{ song.note }}
    </div>
    <div class="roles">
      <div
        v-for="role in roles"
        :key="role.id"
        class="role"
      >
        <div class="role-title">
          <span class="icon">
            <i :class="`mdi mdi-${role.icon}`" />
          </span>
          <span>{{ role.label }}</span>
        </div>
        <div class="role-artists">
          <a
            v-for="a in role.artists"
            :key="a.id"
            role="button"
            class="role-artist"
            @click="toArtist(a)"
          >{{ $truncate(a.name) }} <i class="mdi mdi-open-in-new" /></a>
        </div>
      </div>
    </div>
    <div class="influences">
      <div
        v-if="song.parent_id"
        class="influence"
      >
        <span
          class="icon"
          :style="{backgroundColor: $parent.$parent.timeline.colors[0]}"
        >
          <i class="mdi mdi-arrow-up" />
        </span>
        <span class="text">Adapted from 
          <span>
            {{ $store.state.songs[song.parent_id].label }} 
            ({{ $store.state.songs[song.parent_id].year }})
          </span>
        </span>
      </div>
      <div
        v-if="song.n_children > 0"
        class="influence"
      >
        <span
          class="icon"
          :style="{backgroundColor: $parent.$parent.timeline.colors[2]}"
        >
          <i class="mdi mdi-arrow-down" />
        </span>
        <span class="text">Adapted <b>{{ song.n_children }} </b> times</span>
      </div>
      <div
        v-if="song.cover_ids.length > 0"
        class="influence"
      >
        <span
          class="icon"
          style="background-color: #fca82b;"
        >
          <i class="mdi mdi-microphone" />
        </span>
        <span class="text">Covered <b>{{ song.cover_ids.length }} </b> times</span>
      </div>
    </div>
  </div>
</template>

<script>

import { toArtist } from "@/services/navigator.js";

export default {
	props: {
		song: {
			required: true,
			type: Object
		},
		artist: {
			required: true,
			type: Object
		}
	},
	computed: {

		roles () {
			let roles = [
				{id: "author", label: "Authors", icon: "pencil"},
				{id: "composer", label: "Composers", icon: "music"},
				{id: "interpret", label: "Main interpreters", icon: "microphone"},
			];

			return roles.map(role => {
				let ids = this.song[`${role.id}_ids`].filter(id => id != this.artist.id);
            
				if (this.artist != null && this.song[`${role.id}_ids`].filter(id => id == this.artist.id).length > 0) {
					ids.unshift(this.artist.id);
				}

				let artists = ids.map(id => {
					return this.$store.state.artists[id]; 
				});
      
				role.artists = artists;
        
				return role;
			}).filter(role => role.artists.length > 0);
		},
	},
	methods: {
		toArtist (artist) {
			toArtist(artist.id);
		},
		listText (list) {
			if (list.length < 2) {
				return list[0];
			}

			let string = "";

			for (let i = 0; i < list.length; i++) {
				string += list[i];
				if (i < list.length - 2) {
					string += ", ";
				} else if (i == list.length - 2) {
					string += " et ";
				}
			}

			return string;
		}
	},
};
</script>

<style lang="scss" scoped>
$padding: 1rem 1rem;

.header {
  display: flex;
  justify-content: space-between;
  align-items: top;
  padding: $padding;

  .song-details {
    padding-right: 0.6rem;
  }

  .song-title {
    font-weight: 700;
    line-height: 1.1;
    margin-bottom: 5px;
  }
  .attributes {
    display: flex;

    .attribute {
      font-size: 14px;
      margin-right: 8px;
    }
    .icon {
      color: #666;
      width: auto;
      margin-right: 4px;
    }
  }
}

.note {
  font-size: 0.9rem;
  padding: $padding;
  padding-top: 0;
}

.roles {
  padding: $padding;
  border-top: 1px #e1e1e1 solid;
  .role {
    &:not(:last-child) {
      margin-bottom: 15px;
    }
  }
  .role-title {
    color: #777;
    letter-spacing: 1px;
    text-transform: uppercase;
    font-weight: 500;
    font-size: 10px;
    line-height: 1;
    .icon {
      width: auto;
      height: auto;
      margin-right: 3px;
      color: #111;
    }
  }
  .role-artist {
    line-height: 1;
    font-size: 12px;
    color: #222;
    text-decoration: underline;
    margin-right: 5px;
  }
}

.influences {
  padding: $padding;
  border-top: 1px #e1e1e1 solid;

  .influence {
    display: flex;
    align-items: center;
    &:not(:last-child) {
      margin-bottom: 5px;
    }
    .icon {
      background-color: #a1a1a1;
      border-radius: 100px;
      color: #fff;
      margin-right: 5px;
      font-size: 12px;
      height: 22px;
      width: 22px;
    }
    .text {
      font-size: 14px;
      font-weight: 400;
    }
    a {
      color: #111;
      text-decoration: underline;
    }
  }
}
</style>